import { LockdownState } from "./types";

export function getDefaultState(): LockdownState {
	return {
		lockdownModalVisible: false,
		lockdownConfiguration: null,
		lockdownConfigurations: [],
		staleDataModalVisible: false,
		staleData: [],
		lockdownConfigurationPayload: null,
		selectedClearanceLevel: null
	}
}